import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import {FiArrowRight} from "react-icons/fi";

const ServiceList = [
    {
        image: '/images/services/cta-img-1.png',
        title: 'Keyword Search',
        description: 'As the initial step in optimizing your online presence, we conduct comprehensive ' +
            'research on your target audience and their search behavior. Our aim is to understand the ' +
            'keywords and phrases they are using to find businesses like yours, the volume of searches, ' +
            'and the preferred format of information. This helps us to create a targeted and effective SEO ' +
            'strategy to reach your target market and drive traffic to your website.',
    },
    {
        image: '/images/services/web_sol.svg',
        title: 'On-Page SEO',
        description: 'Our on-page SEO optimization services encompass crucial elements such as Meta tags, ' +
            'Alt tags, website architecture, and keyword density. We guarantee that your website\'s content, ' +
            'code, and structure will be optimized and maintained in accordance with the latest Google standards ' +
            'to ensure maximum visibility and search engine ranking.',
    },
    {
        image: '/images/services/faq.svg',
        title: 'Off-Page SEO',
        description: 'Our team of SEO specialists focuses on external optimization tactics, ' +
            'with a major emphasis on link building. By securing high-quality backlinks from ' +
            'reputable sources, we aim to establish a long-term, effective strategy for boosting your website\'s ' +
            'visibility and credibility. High-quality inbound links demonstrate to search engines like Google ' +
            'that your website is trustworthy, authoritative, and well-regarded among its peers.',
    },
    {
        image: '/images/services/faq.svg',
        title: 'Content Marketing',
        description: 'Our team of SEO specialists will make the most of their expertise to raise your brand\'s ' +
            'visibility, encourage customer loyalty, and build its trust and reputation. We strive to inform and ' +
            'entertain your target audience while creating high-quality leads that turn into significant business revenue. ' +
            'To do this, we produce educational website copy, captivating blog content, and effective guest posts.',
    },
]
const ServiceFive = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
            {ServiceList.map((val, i) => (
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 d-flex" key={i}>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOut="fadeInOut"
                        animateOnce={true}>
                        <div className={`service h-100 d-flex flex-column justify-content-between text-center ${serviceStyle} ${textAlign}`}>
                            <div className="inner">
                                <div className="image">
                                    <img src={`${val.image}`} alt="Service Images"/>
                                </div>
                                <div className="content">
                                    <h4 className="title">
                                        <Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link>
                                    </h4>
                                    <p className="description" dangerouslySetInnerHTML={{__html: val.description}}></p>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceFive;